import React, { Fragment } from 'react';
import { AccordionContent, AccordionGroup } from 'core/controls';
import { useTranslate } from 'core/translate';
import MathBoxAccordionHeader from './MathBoxAccordionHeader';
import SubgroupHeader from './SubgroupHeader';
import OptionList from './OptionList';
import { withNotifications } from '../common/notifications/NotificationsContext';
import { DoubleDagger } from '../common/notifications/NotificationsTrigger';
import Currency from '../common/intl/Currency';

const Header = withNotifications(({ header, count, notifications }) => {
  const { disabled, showNamed } = notifications;

  return (
    <Fragment>
      <span className="accordion-title__text">{header}</span>{' '}
      {disabled ? null : (
        <span
          className="disclaimer"
          onClick={event => {
            event.stopPropagation();
            showNamed('accessories', event);
          }}>
          <DoubleDagger />
        </span>
      )}
      <span> ({count})</span>
    </Fragment>
  );
});

const SelectedAccessoriesGroup = ({ accessories, isOpenDefault }) => {
  const translate = useTranslate();

  if (accessories.length === 0) {
    return null;
  }

  const total = accessories.reduce((total, option) => total + option.msrp, 0);
  const header = translate('component.common.selected.accessories');

  return (
    <AccordionGroup isOpenDefault={isOpenDefault} id="selected-accessories">
      <MathBoxAccordionHeader
        header={<Header header={header} count={accessories.length} />}
        total={
          <span>
            + <Currency value={total} />{' '}
          </span>
        }
      />
      <AccordionContent>
        <SubgroupHeader to="/accessories" analytics={header} />
        <OptionList options={accessories} />
      </AccordionContent>
    </AccordionGroup>
  );
};

SelectedAccessoriesGroup.defaultProps = {
  isOpenDefault: false
};

export default SelectedAccessoriesGroup;
